import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Reusable Card component using our design system
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.hover - Enable hover effects
 * @param {boolean} props.padding - Apply default padding
 */
const Card = ({
  children,
  className,
  hover = true,
  padding = true,
  ...rest
}) => {
  const baseClasses = 'bg-white rounded-lg shadow-md border border-gray-200 transition-shadow duration-200';
  const hoverClasses = hover ? 'hover:shadow-lg' : '';
  const paddingClasses = padding ? 'p-4' : '';
  
  return (
    <div
      className={cn(
        baseClasses,
        hoverClasses,
        paddingClasses,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

/**
 * Card Header component
 */
export const CardHeader = ({ children, className, ...rest }) => (
  <div className={cn('card-header', className)} {...rest}>
    {children}
  </div>
);

/**
 * Card Content component
 */
export const CardContent = ({ children, className, ...rest }) => (
  <div className={cn('card-content', className)} {...rest}>
    {children}
  </div>
);

/**
 * Card Footer component
 */
export const CardFooter = ({ children, className, ...rest }) => (
  <div className={cn('card-footer', className)} {...rest}>
    {children}
  </div>
);

export default Card;